import { useState, useEffect } from 'react';
import { SearchInput } from '@/components';
import GlobalButton, { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { DeleteForever as TrashIcon, Search as SearchIcon } from '@mui/icons-material';

interface SearchBarProps {
  searchValue: string;
  onSearch: (value: string) => void;
}

const SearchBar = ({ searchValue, onSearch }: SearchBarProps) => {
  const [input, setInput] = useState(searchValue);

  // Sincronizar cuando cambie la prop externa
  useEffect(() => {
    setInput(searchValue);
  }, [searchValue]);

  const handleClear = () => {
    setInput('');
    onSearch('');
  };

  const handleSearch = () => {
    onSearch(input);
  };

  return (
    <div className="w-full p-4 flex items-center bg-white rounded-lg shadow-md gap-3">
      <SearchInput
        name="company-name-search"
        placeholder="Buscar empresa"
        value={input}
        onChange={(val) => setInput(val.toString())}
      />

      <GlobalButton
        variant={GlobalButtonVariant.secondaryButton}
        action={handleClear}
      >
        <TrashIcon />
      </GlobalButton>

      <GlobalButton
        variant={GlobalButtonVariant.primaryButton}
        action={handleSearch}
      >
        <SearchIcon />
      </GlobalButton>
    </div>
  );
};

export default SearchBar;
